export default "__VITE_PUBLIC_ASSET__3dd3788c__"